import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";
import {UserService} from "../../services/user.service";
import {Userrole} from "../../shared/interfaces/user";

export const selectWorkplaceGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const userrole = Userrole;
  if (userService.userrole() === userrole.Mitarbeiter) {
    return true;
  }
  router.navigate(["/dashboard"]);
  return false;
};
